__turbopack_context__.v({
  "headingLink": "styles-module__jz4_5G__headingLink",
  "iconLeft": "styles-module__jz4_5G__iconLeft",
  "iconRight": "styles-module__jz4_5G__iconRight",
  "link": "styles-module__jz4_5G__link",
  "linkMain": "styles-module__jz4_5G__linkMain",
  "linkSub": "styles-module__jz4_5G__linkSub",
  "nestedLink": "styles-module__jz4_5G__nestedLink",
  "sublist": "styles-module__jz4_5G__sublist",
});
